// Components==============
import Spinner from 'components/UI/Spinner/Spinner';
import React from 'react';
import './TopLeft.module.scss';
// =========================

export default function TopLeft({
  theme,
  isOpen,
  loading,
}: {
  theme?: ThemeEntity;
  isOpen: boolean;
  loading?: boolean;
}) {
  return (
    <div styleName="wrapper">
      <h1>
        {theme?.name} <Spinner loading={loading} />
      </h1>
      {isOpen && (
        <p>{`${theme?.author?.first_name}  ${theme?.author?.last_name}`}</p>
      )}
    </div>
  );
}
